// Announcement Bar Module - Handles close button functionality and Swiper slider initialization

// Close Button Handler
theme.announcement = (function () {
  function announcementModule(container) {
    const announcementBars = container.querySelectorAll(".announcement-bar");
    
    announcementBars.forEach((element) => {
      element.addEventListener("click", (event) => {
        const target = event.target;
        
        if (target.classList.contains("close__announcement--bar")) {
          target.closest('.announcement-bar')?.remove();
        }
      });
    });
  }
  
  return announcementModule;
})();

// Swiper Slider Initialization
(function() {
  'use strict';
  
  const SWIPER_POLL_INTERVAL = 200;
  const SWIPER_MAX_ATTEMPTS = 10;
  const DEFAULT_DELAY = 3000;
  
  // Initialize a single Swiper slider instance
  // @param {HTMLElement} container - The slider container element
  // @returns {boolean} - True if initialization was successful
  const initSwiper = (container) => {
    if (!container || typeof Swiper !== 'function') {
      return false;
    }
    
    const delay = parseInt(container.dataset.delay, 10) || DEFAULT_DELAY;
    const nextButton = container.querySelector('.swiper-button-next');
    const prevButton = container.querySelector('.swiper-button-prev');
    
    try {
      new Swiper(container, {
        loop: true,
        autoplay: {
          delay: delay,
          disableOnInteraction: false
        },
        speed: 500,
        allowTouchMove: true,
        slidesPerView: 1,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        }
      });
      
      return true;
    } catch (error) {
      console.error('Error initializing Swiper:', error);
      return false;
    }
  };

  // Initialize all announcement sliders on the page
  // @returns {boolean} - True if all sliders were initialized successfully
  const initAllSliders = () => {
    const sliders = document.querySelectorAll('.announcement-slider.swiper');
    
    if (sliders.length === 0) {
      return true; // No sliders to initialize
    }
    
    let initializedCount = 0;
    
    sliders.forEach((container) => {
      if (initSwiper(container)) {
        initializedCount++;
      }
    });
    
    return initializedCount === sliders.length;
  };

  // Attempt to initialize sliders, polling if Swiper is not yet loaded
  const tryInit = () => {
    if (initAllSliders()) {
      return; // Success - all sliders initialized
    }
    
    // Swiper not available - poll until it loads
    let attempts = 0;
    const pollTimer = setInterval(() => {
      if (initAllSliders() || ++attempts >= SWIPER_MAX_ATTEMPTS) {
        clearInterval(pollTimer);
      }
    }, SWIPER_POLL_INTERVAL);
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    window.addEventListener('load', tryInit);
  } else {
    tryInit();
  }
})();
